import * as L from 'leaflet';
import { MapModeEnum } from '../../containers/Map/slice/types';
import { fieldMarkerSvgIcon, transportMarkerSvgIcon } from './MarkerIconSvg';

interface ICreateTempMarkerOptions {
  selected: boolean;
  background: string;
}

export function createTempMarker({
  selected,
  background,
}: ICreateTempMarkerOptions) {
  return new L.DivIcon({
    className: `field-marker-icon`,
    html: `
    <div class="marker-icon marker-color" style="background: ${background}; opacity: ${
      selected ? 1 : 0.9
    }">
        ${fieldMarkerSvgIcon}
      </div>
      `,
  });
}

interface ICreateFieldMarkerOptions {
  selected: boolean;
  name: string;
  culture: string | null;
  colorClass: string | null;
  area: string;
  percentage?: number;
  mode?: MapModeEnum;
}

export function createFieldMarker({
  selected,
  percentage,
  colorClass,
  name,
  culture,
  area,
  mode,
}: ICreateFieldMarkerOptions) {
  return new L.DivIcon({
    className: `field-marker-icon ${selected ? 'is-selected' : ''}`,
    html: `
      <div class="marker-icon marker-color marker-color-${colorClass?.toLowerCase()} " style='background:${colorClass}!important'>
        ${
          (selected && mode === MapModeEnum.progress) ||
          mode === MapModeEnum.taskFields
            ? `${percentage}%`
            : fieldMarkerSvgIcon
        }
      </div>
          <div class="field-info" title="${name}  ${
      culture ? '| ' + culture : ''
    }">
            <div class="field-name">
              ${name}  ${culture ? '| ' + culture : ''}
            </div>
            <div class="field-area">${area}</div>
          </div>
    `,
  });
}

export function createGroupMarkerIcon(cluster: any) {
  return new L.DivIcon({
    className: 'marker-icon-cluster',
    html: `
      <div class="cluster-count">
        ${cluster.getChildCount()}
      </div>
    `,
  });
}

interface ICreateTransportMarkerOptions {
  name: string;
  workerName: string;
  workerPhoneNumber: string | null;
  implement: string | null;
  fuelLevel: string;
  ignitionOn: boolean | null;
}

export const createTransportMarker = ({
  name,
  workerName,
  workerPhoneNumber,
  implement,
  fuelLevel,
  ignitionOn,
}: ICreateTransportMarkerOptions): L.DivIcon => {
  return new L.DivIcon({
    className: `field-marker-icon`,
    html: `
      <div class="marker-icon marker-color transport-marker-icon marker-color-day-break-blue ${
        ignitionOn ? 'active-transport' : ''
      }">
          ${transportMarkerSvgIcon}         
      </div>

      <div class="transport-info">
        <div class="field-name">
          ${name}         
        </div>
     
        <div class="field-area field-name">
          ${implement ?? '-'}
        </div>
        ${
          fuelLevel
            ? `
          <div class="field-name">
            ${fuelLevel}
          </div>
        `
            : ''
        }
      </div>

      <div class="transport-hover-details">
        <div class="transport-worker-name">
          <b>
          ${workerName || '-'}
          </b>
        </div>
        <div class="transport-worker-phone">
          ${workerPhoneNumber || '-'}
        </div>
      </div>
    `,
  });
};

export const createUserMarker = (): L.DivIcon => {
  return new L.DivIcon({
    className: `field-marker-icon`,
    html: `
      <div class="user-marker-icon ">
      </div>
    `,
  });
};
